import Layout from '@/components/Layout/Layout'

import ErrorComponentBase, { type ErrorProps } from './ErrorComponentBase'

export default function ErrorComponent(props: ErrorProps): JSX.Element {
  const { statusCode } = props

  return (
    <Layout title={statusCode ? `Error ${statusCode}` : 'Unknown error'} hideLoginButton>
      <ErrorComponentBase {...props} />
    </Layout>
  )
}
